if (!customElements.get('newsletter-form')) {
  class NewsletterForm extends HTMLElement {
    connectedCallback() {
      const companyId  = this.getAttribute('company-id');
      const emailList  = this.getAttribute('list-id');
      const smsList    = this.getAttribute('sms-list-id');
      console.log('[newsletter-form] connected', { companyId, emailList, smsList });
      if (!companyId || !emailList) { console.warn('[newsletter-form] missing config'); return; }

      const form = this.querySelector('form');
      if (!form) return;

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const emailEl   = form.querySelector('[type="email"]');
        const phoneEl   = form.querySelector('[type="tel"]');
        const btn       = form.querySelector('[type="submit"]');
        const successEmail = form.querySelector('[data-klv-success="email"]');
        const successSms   = form.querySelector('[data-klv-success="sms"]');
        const successBoth  = form.querySelector('[data-klv-success="both"]');
        const errorEl      = form.querySelector('[data-klv-error]');
        const email     = emailEl?.value.trim() ?? '';
        const phone     = phoneEl?.value.trim() ?? '';

        if (!email && !phone) return;

        btn.disabled = true;
        [successEmail, successSms, successBoth].forEach(el => { if (el) el.hidden = true; });
        if (errorEl) errorEl.hidden = true;

        let formattedPhone = null;
        if (phone) {
          let digits = phone.replace(/\D/g, '');
          if (digits.length === 10) digits = '1' + digits;
          formattedPhone = '+' + digits;
        }

        const klvPost = (listId, profileAttrs) => fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'revision': '2026-04-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Footer Newsletter',
                  profile: { data: { type: 'profile', attributes: profileAttrs } }
                },
                relationships: { list: { data: { type: 'list', id: listId } } }
              }
            })
          }
        );

        const profileAttrs = {};
        if (email) profileAttrs.email = email;
        if (formattedPhone) profileAttrs.phone_number = formattedPhone;

        const calls = [];
        if (email) calls.push(klvPost(emailList, profileAttrs));
        if (formattedPhone && smsList) calls.push(klvPost(smsList, profileAttrs));

        Promise.all(calls)
          .then(responses => {
            responses.forEach(res => console.log('[Klaviyo]', res.status));
            const allOk = responses.every(r => r.status === 202);
            if (allOk) {
              const el = (email && formattedPhone) ? successBoth : email ? successEmail : successSms;
              if (el) el.hidden = false;
              form.reset();
            } else {
              if (errorEl)   errorEl.hidden = false;
              btn.disabled = false;
            }
          })
          .catch(() => {
            if (errorEl) errorEl.hidden = false;
            btn.disabled = false;
          });
      });
    }
  }
  customElements.define('newsletter-form', NewsletterForm);
}
